import { render, staticRenderFns } from "./GoodDamageTypesForm.vue?vue&type=template&id=62938afe&scoped=true"
import script from "./GoodDamageTypesForm.vue?vue&type=script&lang=ts"
export * from "./GoodDamageTypesForm.vue?vue&type=script&lang=ts"
import style0 from "./GoodDamageTypesForm.vue?vue&type=style&index=0&id=62938afe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62938afe",
  null
  
)

export default component.exports